export const GET_SEMI_PRODUCTS = 'GET_MATERIALS';
export const GET_SEMI_PRODUCTS_SUCCESS = 'GET_MATERIALS_SUCCESS';
export const GET_SEMI_PRODUCTS_FAIL = 'GET_MATERIALS_FAIL';
export const GET_SEMI_PRODUCTS_CLEAR = 'GET_MATERIALS_CLEAR';
